import { getRequest, getTable, postRequest } from "./requestTemplates";
import { Packet } from "../Interfaces/commonDtos";
import { Report } from "../Interfaces/TableInterfaces";
import { DropdownItem } from "../Interfaces/dropdownInterfaces";
import type {
  IAssetClassSearchParams,
  IAssetClassTableReport,
  IInstrumentDropdownItem,
  IUpdateAssetTypeOneParams,
  IUpdateAssetTypeParams,
} from "src/Interfaces/assetClass";
import { NO_ASSET_CLASS_ID } from "src/Interfaces/assetClass";

/**
 * Asset Class
 * دراپ‌داون نمادها (فقط نمادهای غیر آپشنی)
 *
 * @async
 */
export const getAssetClassInstrumentsDropDown = (): Promise<
  IInstrumentDropdownItem[]
> => getRequest("/v1/assetclass/instruments/dropdown");

/**
 * Asset Class
 * دراپ‌داون طبقه‌های دارایی
 *
 * @async
 */
export const getAssetTypesDropDown = (): Promise<DropdownItem[]> =>
  getRequest("/v1/assetclass/assettypes/dropdown");

/**
 * Asset Class
 * دراپ‌داون طبقه‌های دارایی به همراه گزینه «بدون طبقه» (برای فیلتر جدول)
 *
 * @async
 */
export const getAssetTypesFilterDropDown = (): Promise<DropdownItem[]> =>
  getAssetTypesDropDown().then((res) => [
    // id kept as string to match the server option ids ("1", "14", ...)
    { id: NO_ASSET_CLASS_ID.toString(), name: "بدون طبقه" },
    ...res,
  ]);

/**
 * Asset Class
 * جدول تنظیمات طبقه دارایی
 *
 * @param {IAssetClassSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 */
export const getAssetClassTable = (
  searchParam: IAssetClassSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IAssetClassTableReport>> =>
  getTable<IAssetClassSearchParams, IAssetClassTableReport>(
    "/v1/assetclass/table",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * Asset Class
 * آپدیت گروهی طبقه دارایی
 *
 * @param {IUpdateAssetTypeParams} params
 * @async
 */
export const updateAssetType = (
  params: IUpdateAssetTypeParams,
): Promise<Packet<boolean>> =>
  postRequest("/v1/assetclass/assettype/update", params);

/**
 * Asset Class
 * آپدیت تکی طبقه دارایی و ویژگی‌های نماد
 *
 * @param {IUpdateAssetTypeOneParams} params
 * @async
 */
export const updateAssetTypeOne = (
  params: IUpdateAssetTypeOneParams,
): Promise<Packet<boolean>> =>
  postRequest("/v1/assetclass/assettype/update-one", params);
